<template>
  <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">
                    <h3 class="title has-text-grey">INSA | BackOffice</h3>
                    <p class="subtitle has-text-grey">Introduza a password de acesso.</p>
                    <div class="box">
                      <div class="field">
                          <div class="control">
                              <input class="input is-large" type="password" placeholder="Password" v-model="password">
                          </div>
                      </div>
                      <button class="button is-block is-info is-large is-fullwidth" v-on:click="login()">Entrar</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
  
<script>
  export default {
    data(){
      return {
        password: ''
      }
    },
  
    methods: {
      login(){
        if (this.password == "INSA_2020!") {
          this.$emit('entrar')
        }
      },
    }
  }
</script>